import _ from 'lodash';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
const FIDP_API_ENABLED = config.servers.fidp.enabled;
const FIDP_API_URL = config.servers.fidp.url;
export const ALL_ROLE_POSITION = 'zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz';
export interface OrganDto {
  id: string; // 부서 코드 또는 사용자 ID
  name: string; // 부서 또는 사용자 이름
  type: 'dept' | 'user' | 'dummy' | 'dummyRoot'; // 트리 노드 종류
  // TODO
  /** ==> 더미가 어떻게 되어있는지 재환수석님 확인 필요... dummy type???
   * type (Type): 트리 노드 종류
dept: 부서
user: 사용자
dummy: 더미
트리 컨트롤의 +/- 표시를 출력하기 위한 더미 노드
자식 노드가 없는 부서 노드에 하나 추가
dummyRoot: 더미 루트
중간 관리자인 경우 표시하는 관리 부서 목록을 묶는 최상위 노드
   */
  children: OrganDto[];
}
export interface OrganServerDto {
  id: string | null; // 부서 코드 또는 사용자 ID
  name: string | null; // 부서 또는 사용자 이름
  type: 'dept' | 'user' | 'dummy' | 'dummyRoot'; // 트리 노드 종류
  // TODO
  /** ==> 더미가 어떻게 되어있는지 재환수석님 확인 필요... dummy type???
   * type (Type): 트리 노드 종류
dept: 부서
user: 사용자
dummy: 더미
트리 컨트롤의 +/- 표시를 출력하기 위한 더미 노드
자식 노드가 없는 부서 노드에 하나 추가
dummyRoot: 더미 루트
중간 관리자인 경우 표시하는 관리 부서 목록을 묶는 최상위 노드
   */
  children: OrganServerDto[];
}
export const convertServerDto = (serverDto: OrganServerDto): OrganDto => {
  return {
    id: serverDto.id === null ? '' : serverDto.id,
    name: serverDto.name === null ? '' : serverDto.name,
    type: serverDto.type,
    children: serverDto.children.map((child) => convertServerDto(child)),
  };
};
interface OrganApi {
  tree(): Promise<OrganDto[]>;
  treeById(id: string): Promise<OrganDto[]>;
  treeByDept(): Promise<OrganDto[]>;
}
class OrganServerApi implements OrganApi {
  async tree(): Promise<OrganDto[]> {
    const resp = await axios.get<OrganDto[]>(`${FIDP_API_URL}/api/organs/tree2?onlyDept=N&root=Y`);
    return resp.data;
  }
  async treeById(id: string): Promise<OrganDto[]> {
    const resp = await axios.get<OrganDto[]>(
      `${FIDP_API_URL}/api/organs/tree2?onlyDept=N&path=${id}`
    );
    return resp.data;
  }
  async treeByDept(): Promise<OrganDto[]> {
    const resp = await axios.get<OrganServerDto[]>(`${FIDP_API_URL}/api/organs/tree3`);
    return resp.data.map((data) => convertServerDto(data));
  }
}
const organApi = new OrganServerApi();
export default organApi;
